import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { FlashMessageGenerateTokenDto, FlashMessageGenerateTokenDtoImpl } from './flashmessagegeneratetoken';


export class FlashMessageGenerateTokenBuilder
{
    constructor(private flashMessageList: any)
    {
        if(flashMessageList === undefined)
        {
            throw new NoDataException("FlashMessage data doesnt exists");
        }
    }

    buildAll(): FlashMessageGenerateTokenDto
    {
        return this.parseFlashMessageDetailsResponse();
    }
    
    private parseFlashMessageDetailsResponse(): FlashMessageGenerateTokenDto
    {  
            let flashmessagedto = new FlashMessageGenerateTokenDtoImpl();
            flashmessagedto.setAccessToken(this.flashMessageList.accessToken);
         
        return flashmessagedto;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/flashmessagegenereratetoken/flashmessagegeneratetokenbuilder.ts